import apiClient from "../network/apiClient";
import { ToastContainer, toast } from 'react-toastify';


const withTranslation = (apiFunction, translateFn) => {
    return async (...args) => {
        const result = await apiFunction(...args);
        if (result.status && translateFn) {
            return {
                ...result,
                response: await translateResponse(result.response, translateFn)
            };
        }
        return result;
    };
};

const translateResponse = async (data, translateFn) => {
    if (data.data && Array.isArray(data.data)) {
        const translatedItems = await Promise.all(
            data.data.map(async item => ({
                ...item,
                name: await translateFn(item.name)
            }))
        );
        return { ...data, data: translatedItems };
    }
    return data;
};

class CategoryProvider {
    getTranslatedCategoryList = (translateFn) => {
        return withTranslation(this.getCategoryList.bind(this), translateFn);
    };
    async getCategoryList(input) {
        try {
            const response = await apiClient.get(`categories`);
            console.log("@@@@@@", response)
            const message = response.data?.message ?? "Something went wrong";
            if ((response.status == 200 || response.status == 201) && response) {
                return {
                    status: true,
                    response: response.data
                };
            } else {
                return { status: false, response: [] };
            }
        } catch (error) {
            return { status: false, response: [] };
        }
    }

    async getCategoryDet(id, limit = 20, page = 0, filters = {}) {
        try {
            // Backward compatibility: If filters is a string, treat it as subCategoryId
            const actualFilters = typeof filters === 'string' ? { subCategoryId: filters } : filters;

            let url = `product/list/dtls?limit=${limit}&page=${page}`;
            if (id) url += `&categoryId=${id}`;
            if (actualFilters.subCategoryId) url += `&subCategoryId=${actualFilters.subCategoryId}`;
            if (actualFilters.brandId) url += `&brandId=${actualFilters.brandId}`;
            if (actualFilters.priceFromRange !== undefined) url += `&priceFromRange=${actualFilters.priceFromRange}`;
            if (actualFilters.priceToRange !== undefined) url += `&priceToRange=${actualFilters.priceToRange}`;

            const response = await apiClient.get(url);
            if ((response.status == 200 || response.status == 201) && response) {
                return {
                    status: true,
                    response: response.data
                };
            } else {
                return { status: false, response: [] };
            }
        } catch (error) {
            return { status: false, response: [] };
        }
    }

    async getBrandList() {
        try {
            const response = await apiClient.get(`brand/list/dtls`);
            if (response.status == 200 || response.status == 201) {
                return { status: true, response: response.data };
            }
            return { status: false, response: [] };
        } catch (error) {
            return { status: false, response: [] };
        }
    }

    async getSubCategoryList(categoryId, brandId) {
        try {
            let url = `subcategories?categoryId=${categoryId}`;
            if (brandId) {
                url += `&brandId=${brandId}`;
            }
            const response = await apiClient.get(url);
            if (response.status == 200 || response.status == 201) {
                return { status: true, response: response.data };
            }
            return { status: false, response: [] };
        } catch (error) {
            return { status: false, response: [] };
        }
    }

    async getCourseDet(id) {
        try {
            const response = await apiClient.get(`product/` + id);
            if ((response.status == 200 || response.status == 201) && response) {
                return {
                    status: true,
                    response: response.data
                };
            } else {
                return {
                    status: false,
                    response: []
                };
            }
        } catch (error) {
            return {
                status: false,
                response: []
            };
        }
    }
    // Duplicate removed

    async getReviewDet(id) {
        try {
            const response = await apiClient.get(`review/get-review/` + id);
            if ((response.status == 200 || response.status == 201) && response) {
                return {
                    status: true,
                    response: response.data
                };
            } else {
                return {
                    status: false,
                    response: []
                };
            }
        } catch (error) {
            return {
                status: false,
                response: []
            };
        }
    }





    async addReview(input) {
        try {
            const response = await apiClient.post("review/add", input);
            const message = response.data?.message ?? "Something went wrong";
            if (response.status == 200 || response.status == 201 && response) {
                // notification.showAlertNotification(response.data.message, true);
                toast(message);

                return {
                    status: response.status,
                    response: response.data
                };
            } else {
                // notification.showAlertNotification(message, false);

                return {
                    status: false,
                    response: []
                };
            }

        } catch (error) {
            // notification.showAxiosErrorAlert(error);
            toast.error("Something went wrong! Please try again.");
            return {
                status: false,
                response: []
            };
        }
    }

    async getProduct(search = '', limit = 20) {
        try {
            const response = await apiClient.get(`product/list/dtls?search=${search}&limit=${limit}`);
            if (response.status == 200 || response.status == 201) {
                return { status: true, response: response };
            } else {
                return null;
            }
        } catch (error) {
            return null;
        }
    }

    async getCourseCategoryList(id) {
        try {
            const response = await apiClient.get(`category/get`); // Ignoring ID for now as we don't have subcategory API
            if ((response.status == 200 || response.status == 201) && response) {
                return {
                    status: true,
                    response: response.data
                };
            } else {
                return {
                    status: false,
                    response: []
                };
            }
        } catch (error) {
            return {
                status: false,
                response: []
            };
        }
    }
}
const apiCategory = new CategoryProvider()
export default apiCategory